// Copyright 2014-2018 DNDG srl <https://dndg.it>
// Some rights reserved. See the LICENSE file for licensing details.

import { ActionContext } from 'vuex';
import { get, post, del, ApiResult } from '../../helpers/api';
import { checkResult } from '../../store';

async function loadApps(ctx: ActionContext<any,any>) {
    const endpoint = `/babel/_api/v1/apps`;

    let result = await get(endpoint).then(res => res.data) as ApiResult<any[]>;
    let resultData = checkResult(ctx, result);
    if (resultData) {
        return resultData;
    }
    
    return null;
}

async function loadAppVersions(ctx: ActionContext<any,any>, appId: number) {
    const endpoint = `/babel/_api/v1/apps/${appId}/versions`;

    let result = await get(endpoint).then(res => res.data) as ApiResult<any[]>;
    let resultData = checkResult(ctx, result);
    if (resultData) {
        return resultData;
    }
    
    return null;
}

async function loadAppVersionData(ctx: ActionContext<any,any>, data : { appId: number, versionId: number}) {
    const endpoint = `/babel/_api/v1/apps/${data.appId}/versions/${data.versionId}/summary`;

    let result = await get(endpoint).then(res => res.data) as ApiResult<any[]>;
    let resultData = checkResult(ctx, result);
    if (resultData) {
        return resultData;
    }
    
    return null;
}

async function updateTranslationData(ctx: ActionContext<any,any>, appVersionData: any) {
    const endpoint = `/babel/_api/v1/apps/update`;

    let result = await post(endpoint, appVersionData).then(res => res.data) as ApiResult<any[]>;
    let resultData = checkResult(ctx, result);
    if (resultData) {
        return resultData;
    }
    
    return null;
}

export default {
    loadApps,
    loadAppVersions,
    loadAppVersionData,
    updateTranslationData
}